:host {

    // Base HTML elements applying Polaris styles
    p {
        @extend %polaris-font-style-paragraph-medium;
        margin-top: 0;
    }

    ti-autocomplete {
        --ti-autocomplete-list-max-height: 250px; // prevent dropdown list going past dialog container
    }

    .ti-autocomplete-myti-container {
        min-height: 315px; // Reduce layout shift when changing from tab to tab (Upload file -> Add by part number)
    }

    .ti-autocomplete-myti-list-parts {
        margin-top: $polaris-space-6;
        margin-bottom: $polaris-space-2;

        ti-chip {
            margin-right: $polaris-space-2;
            margin-bottom: $polaris-space-2;
        }
    }
}
